import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import { ChevronLeft } from 'lucide-react';

const CGUPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Logo size="default" linkTo="/" />
            <Link to="/" className="text-slate-600 hover:text-slate-900 flex items-center text-sm">
              <ChevronLeft className="w-4 h-4 mr-1" /> Retour à l'accueil
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Conditions Générales d'Utilisation</h1>
        
        <div className="prose prose-slate max-w-none">
          <p className="text-slate-600 mb-6">Dernière mise à jour : Mars 2026</p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Objet</h2>
            <p className="text-slate-700 mb-4">
              Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités 
              et conditions d'utilisation des services proposés par 10 Millions Investor (ci-après "la Plateforme"), 
              ainsi que de définir les droits et obligations des parties dans ce cadre.
            </p>
            <p className="text-slate-700">
              L'utilisation de la Plateforme implique l'acceptation pleine et entière des présentes CGU.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Accès à la Plateforme</h2>
            <p className="text-slate-700 mb-4">
              La Plateforme est accessible gratuitement à tout utilisateur disposant d'un accès à Internet. 
              Certaines fonctionnalités sont réservées aux utilisateurs ayant souscrit un abonnement payant.
            </p>
            <p className="text-slate-700">
              L'utilisateur est responsable de son équipement informatique et de son accès à Internet.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Inscription et Compte Utilisateur</h2>
            <p className="text-slate-700 mb-4">
              Pour accéder aux services de la Plateforme, l'utilisateur doit créer un compte en fournissant 
              des informations exactes et à jour. L'utilisateur est responsable de la confidentialité de ses 
              identifiants de connexion.
            </p>
            <p className="text-slate-700">
              Tout compte créé est personnel et ne peut être cédé ou transféré à un tiers.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Services Proposés</h2>
            <p className="text-slate-700 mb-4">La Plateforme propose les services suivants :</p>
            <ul className="list-disc pl-6 text-slate-700 space-y-2">
              <li>Calculateur de rentabilité immobilière</li>
              <li>Outil pour Marchands de Biens</li>
              <li>Agent IA pour l'analyse d'annonces immobilières (abonnés Club)</li>
              <li>Formations en ligne sur l'investissement immobilier</li>
              <li>Communauté d'investisseurs</li>
              <li>Messagerie entre membres</li>
              <li>Annuaire des membres</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Abonnements et Paiements</h2>
            <p className="text-slate-700 mb-4">
              Certains services sont accessibles moyennant le paiement d'un abonnement mensuel ou annuel. 
              Les tarifs sont indiqués sur la page de tarification de la Plateforme.
            </p>
            <p className="text-slate-700">
              Les paiements sont sécurisés par Stripe. L'utilisateur peut résilier son abonnement à tout moment.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Propriété Intellectuelle</h2>
            <p className="text-slate-700">
              L'ensemble des contenus présents sur la Plateforme (textes, images, logos, outils, etc.) 
              sont protégés par le droit de la propriété intellectuelle. Toute reproduction non autorisée 
              est strictement interdite.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Responsabilité</h2>
            <p className="text-slate-700 mb-4">
              Les calculs et analyses fournis par la Plateforme sont donnés à titre indicatif uniquement. 
              L'utilisateur reste seul responsable de ses décisions d'investissement.
            </p>
            <p className="text-slate-700">
              La Plateforme ne saurait être tenue responsable des dommages directs ou indirects résultant 
              de l'utilisation des services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Modification des CGU</h2>
            <p className="text-slate-700">
              La Plateforme se réserve le droit de modifier les présentes CGU à tout moment. 
              Les utilisateurs seront informés de toute modification par email ou notification sur la Plateforme.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Droit Applicable</h2>
            <p className="text-slate-700">
              Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux français 
              seront seuls compétents.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-slate-900 mb-4">10. Contact</h2>
            <p className="text-slate-700">
              Pour toute question relative aux présentes CGU, vous pouvez nous contacter à l'adresse : 
              <a href="mailto:bonjour@10millionsinvestor.com" className="text-[#0D47A1] hover:underline ml-1">
                bonjour@10millionsinvestor.com
              </a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center text-sm">
          <p>© 2026 10 Millions Investor. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
};

export default CGUPage;
